import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/store/authStore';

const HOUR_MS = 60 * 60 * 1000;
const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'] as const;

/**
 * Déconnexion automatique après une période d'inactivité (brief : 8 h).
 * Réinitialise le minuteur à chaque interaction utilisateur.
 */
export function useIdleLogout(idleHours = 8): void {
  const clearSession = useAuthStore((s) => s.clearSession);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (!isAuthenticated) return;

    const reset = () => {
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => clearSession(), idleHours * HOUR_MS);
    };

    reset();
    ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, reset, { passive: true }));
    return () => {
      window.clearTimeout(timer.current);
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, reset));
    };
  }, [isAuthenticated, idleHours, clearSession]);
}
